import { getDefaultPalletteHeader } from "../../../../../helpers";

export const getInputColor = ({ node, flow }) => {
    const nodeFromFlowData = node?.id ? flow?.data?.nodes?.find(n => n.id === node.id) : node; // node.id === page/symbol
    const inputColor = nodeFromFlowData && nodeFromFlowData.color || getDefaultPalletteHeader()
    return inputColor;
}